module.exports = __webpack_public_path__ + "static/media/R-330XLHD_CrossSection.70cab9b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/chambers/de/R-330XLHD_CrossSection.png
// module id = 472
// module chunks = 0